<template>
  <div class="menu-reducido" style="background-color: black">
    <div class="container">
      <el-row type="flex" class="row-bg" justify="end">
        <el-col :xs="10" :sm="4">
          <!-- <a href="https://ns.suizoargentina.com/newlog" class="menu-boton-carro-reducido">
            <img src="@/assets/new/login_blanco.svg" class="logo-reducido" @click="menuActivo = 'home'" alt="Login Farma" />
          </a> -->
          <router-link to="/" @click="menuActivo = 'home'">
            <img src="@/assets/new/login_blanco.svg" class="logo-mobile logo-reducido" alt="logo" />
          </router-link>
          <!-- <router-link
            to="/"
            @click.prevent="
              menuActivo = 'home'
              $scrollTo('#home', 0)
            ">
            <img src="@/assets/new/login_blanco.svg" class="logo-reducido" @click="menuActivo = 'home'" alt="Login Farma" />
          </router-link> -->
        </el-col>

        <el-col :xs="{ span: 14, offset: 0 }" class="hidden-md-and-up">
          <div class="menu-reducido-right">
            <a href="https://ns.suizoargentina.com/newlog" class="menu-boton-carro-reducido">
              <i class="el-icon-user-solid"></i>
            </a>

            <a @click="menuMobile = true" class="menu-boton-carro-reducido">
              <i class="el-icon-more"></i>
            </a>

            <img @click="switchLocale('es')" src="@/assets/SVG/es_text_recolored.svg" class="es-reducido" alt="Cambiar a sitio en español - Log In Farma" />

            <img @click="switchLocale('en')" src="@/assets/SVG/en_text_recolored.svg" class="es-reducido" alt="Change to English website - Log In Farma" />
          </div>
        </el-col>

        <el-col :sm="20" class="hidden-sm-and-down">
          <div class="menu-reducido-right">
            <ul>
              <li>
                <a href="" :class="{ menuActivo: menuActivo == 'home' }" v-scroll-to="{ el: '#home', offset: 0 }" @click="menuActivo = 'home'">
                  <i class="el-icon-s-home" style="font-size: 18px"></i>
                </a>
              </li>

              <li>
                <a href="" :class="{ menuActivo: menuActivo == 'nosotros' }" v-scroll-to="{ el: '#nosotros', offset: 0 }" @click="menuActivo = 'nosotros'">
                  {{ $t('header.nosotros') }}
                </a>
              </li>

              <li>
                <a href="" :class="{ menuActivo: menuActivo == 'calidad' }" v-scroll-to="{ el: '#calidad', offset: 0 }" @click="menuActivo = 'calidad'">
                  {{ $t('header.calidad') }}
                </a>
              </li>

              <li>
                <a href="" :class="{ menuActivo: menuActivo == 'servicios' }" v-scroll-to="{ el: '#servicios', offset: -100 }" @click="menuActivo = 'servicios'">
                  {{ $t('header.servicios') }}
                </a>
              </li>

              <li>
                <a href="" :class="{ menuActivo: menuActivo == 'infra' }" v-scroll-to="{ el: '#infra', offset: -80 }" @click="menuActivo = 'infra'">
                  {{ $t('header.infraestructura') }}
                </a>
              </li>

              <li>
                <a href="" :class="{ menuActivo: menuActivo == 'galeria' }" v-scroll-to="{ el: '#galeria', offset: 0 }" @click="menuActivo = 'galeria'">
                  {{ $t('header.galeria') }}
                </a>
              </li>

              <li>
                <a href="" :class="{ menuActivo: menuActivo == 'sucursales' }" v-scroll-to="{ el: '#sucursales', offset: -100 }" @click="menuActivo = 'sucursales'">
                  {{ $t('header.sucursales') }}
                </a>
              </li>

              <li>
                <a href="" :class="{ menuActivo: menuActivo == 'contacto' }" v-scroll-to="{ el: '#contacto', offset: 100 }" @click="menuActivo = 'contacto'">
                  {{ $t('header.contacto') }}
                </a>
              </li>

              <li>
                <a href="https://log-in.com.ar/sala-de-prensa/" :class="{ menuActivo: menuActivo == 'sala-de-prensa' }" target="_blank">
                  {{ $t('header.prensa') }}
                </a>
              </li>
            </ul>

            <a href="https://login.microsoftonline.com/" target="_blank" class="menu-boton-webmail-reducido" style="text-decoration: none; font-size: 14px">
              <i class="el-icon-message"></i>
            </a>

            <a href="https://ns.suizoargentina.com/newlog/" target="_blank" class="menu-boton-carro-reducido" style="text-decoration: none; font-size: 14px">
              {{ $t('header.carro') }}
            </a>

            <img @click="switchLocale('es')" src="@/assets/SVG/es_text.svg" class="es-reducido" alt="Cambiar a sitio en español - Log In Farma" />

            <img @click="switchLocale('en')" src="@/assets/SVG/en_text.svg" class="es-reducido" alt="Change to English website - Log In Farma" />

            <a href="https://www.instagram.com/loginfarma" target="_blank" class="menu-boton-ig">
              <img src="@/assets/SVG/ig.svg" alt="Instagram Login Farma" />
            </a>

            <a href="https://www.linkedin.com/company/loginfarma/" target="_blank" class="menu-boton-in">
              <img src="@/assets/SVG/in.svg" alt="Linkedin Login Farma" />
            </a>

            <a href="https://www.linkedin.com/company/loginfarma/" target="_blank" class="menu-boton-yt">
              <img src="@/assets/SVG/yt.svg" alt="Youtube Login Farma" />
            </a>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-dialog :visible.sync="menuMobile" :fullscreen="true" :show-close="false" :append-to-body="true" class="body-mobil">
      <router-link to="/" @click="irA('principal')">
        <img src="@/assets/new/login_blanco.svg" class="logo-mobile" alt="logo" />
      </router-link>
      <ul class="menu-ul-mobile">
        <!-- <li>
    <a href="" :class="{'menuActivo': menuActivo == 'home'}" v-scroll-to="{ el: '#home', offset: 0 }"
      @click="menuActivo = 'home'"><i class="el-icon-s-home" style="font-size:18px"></i></a>
  </li> -->
        <li>
          <el-button
            class="btn-link"
            type="default"
            tag="router-link"
            to="/"
            :class="{ menuActivo: menuActivo == 'nosotros' }"
            v-scroll-to="{ el: '#nosotros', offset: 0 }"
            @click="irA('nosotros')">
            {{ $t('header.nosotros') }}
          </el-button>
        </li>
        <li>
          <el-button
            class="btn-link"
            type="default"
            tag="router-link"
            to="/"
            :class="{ menuActivo: menuActivo == 'servicios' }"
            v-scroll-to="{ el: '#servicios', offset: -100 }"
            @click="irA('servicios')">
            <!-- @click="menuActivo = 'servicios'"> -->
            {{ $t('header.servicios') }}
          </el-button>
        </li>
        <!-- <el-button class="btn-link">
          <router-link to="/" :class="{ menuActivo: menuActivo == 'nosotros' }" v-scroll-to="{ el: '#nosotros', offset: 0 }" @click="menuActivo = 'nosotros'">
            {{ $t('header.nosotros') }}
          </router-link>
        </el-button> -->
        <!-- <el-button>
          <router-link to="/" :class="{ menuActivo: menuActivo == 'nosotros' }" v-scroll-to="{ el: '#nosotros', offset: 0 }" @click="menuActivo = 'nosotros'">
            {{ $t('header.nosotros') }}
          </router-link>
        </el-button> -->

        <!-- <el-button class="btn-link">
          <router-link to="/" :class="{ menuActivo: menuActivo == 'servicios' }" v-scroll-to="{ el: '#servicios', offset: -100 }" @click="menuActivo = 'servicios'">
            {{ $t('header.servicios') }}
          </router-link>
        </el-button> -->
        <li>
          <el-button
            class="btn-link"
            type="default"
            tag="router-link"
            to="/"
            :class="{ menuActivo: menuActivo == 'infra' }"
            v-scroll-to="{ el: '#infra', offset: -80 }"
            @click="irA('infra')">
            <!-- @click="menuActivo = 'infra'"> -->

            {{ $t('header.infraestructura') }}
          </el-button>
        </li>
        <!-- <li>
          <router-link to="/" :class="{ menuActivo: menuActivo == 'infra' }" v-scroll-to="{ el: '#infra', offset: -80 }" @click="menuActivo = 'infra'">
            {{ $t('header.infraestructura') }}
          </router-link>
        </li> -->
        <li>
          <el-button
            class="btn-link"
            type="default"
            tag="router-link"
            to="/"
            :class="{ menuActivo: menuActivo == 'calidad' }"
            v-scroll-to="{ el: '#calidad', offset: -90 }"
            @click="irA('calidad')">
            {{ $t('header.calidad') }}
          </el-button>
        </li>
        <!-- <li>
          <router-link to="/" :class="{ menuActivo: menuActivo == 'calidad' }" v-scroll-to="{ el: '#calidad', offset: -90 }" @click="menuActivo = 'calidad'">
            {{ $t('header.calidad') }}
          </router-link>
        </li> -->
        <li>
          <el-button
            class="btn-link"
            @click="irA('trabaja')"
            type="default"
            tag="router-link"
            :to="'/trabaja-nosotros'"
            :class="{ menuActivo: menuActivo === 'trabaja' }"
            v-scroll-to="{ el: '#', offset: 0 }">
            {{ $t('header.trabaja') }}
          </el-button>
        </li>
        <!-- <li>
          <router-link to="/trabaja-nosotros" :class="{ menuActivo: menuActivo === 'trabaja' }" v-scroll-to="{ el: '#', offset: 0 }">
            {{ $t('header.trabaja') }}
          </router-link>
        </li> -->
        <li>
          <el-button
            class="btn-link"
            type="default"
            tag="router-link"
            to="/"
            :class="{ menuActivo: menuActivo == 'contacto' }"
            v-scroll-to="{ el: '#contacto', offset: 100 }"
            @click="irA('contacto')">
            {{ $t('header.contacto') }}
          </el-button>
        </li>
        <!-- <li>
          <router-link to="/" :class="{ menuActivo: menuActivo == 'contacto' }" v-scroll-to="{ el: '#contacto', offset: 100 }" @click="menuActivo = 'contacto'">
            {{ $t('header.contacto') }}
          </router-link>
        </li> -->

        <!-- <li>
          <a href="" :class="{ menuActivo: menuActivo == 'contacto' }" v-scroll-to="{ el: '#contacto', offset: 100 }" @click="menuActivo = 'contacto'">
            {{ $t('header.contacto') }}
          </a>
        </li> -->
        <li>
          <el-button class="btn-link" type="default">
            <a href="https://log-in.com.ar/sala-de-prensa/" :class="{ menuActivo: menuActivo == 'sala-de-prensa' }" target="_blank">
              {{ $t('header.prensa') }}
            </a>
          </el-button>
        </li>
        <!-- <li>
          <a href="https://log-in.com.ar/sala-de-prensa/" :class="{ menuActivo: menuActivo == 'sala-de-prensa' }" target="_blank">
            {{ $t('header.prensa') }}
          </a>
        </li> -->
        <li>
          <el-button class="btn-link-orange" type="default">
            <a href="https://seguimiento.log-in.com.ar/#/" :class="{ menuActivo: menuActivo == 'sala-de-prensa' }" target="_blank">
              {{ $t('header.carro') }} <i class="el-icon-caret-right"></i>
            </a>
          </el-button>
        </li>
        <!-- <li style="background-color: #d35915; border-color: #d35915">
          <a href="https://ns.suizoargentina.com/newlog/" :class="{ menuActivo: menuActivo == 'sala-de-prensa' }" target="_blank">
            {{ $t('header.carro') }}
          </a>
        </li> -->
      </ul>

      <el-button type="warning" @click="menuMobile = false" style="width: 100%; background-color: transparent; border-color: #d35915">
        {{ $t('header.cerrarMenu') }}
      </el-button>
      <div style="text-align: center">
        <a href="https://www.instagram.com/loginfarma" style="margin: 40px 40px 0px 0px" target="_blank" class="menu-boton-mobile">
          <img src="@/assets/SVG/ig.svg" alt="" />
        </a>

        <a href="https://www.linkedin.com/company/loginfarma/" style="margin: 40px 0px 0px 40px" target="_blank" class="menu-boton-mobile">
          <img src="@/assets/SVG/in.svg" alt="ico-linkedin" />
        </a>
      </div>
      <!-- <a href="https://www.linkedin.com/company/loginfarma/" target="_blank" class="menu-boton-mobile"> <img
          src="@/assets/SVG/yt.svg" alt="ico-linkedin"></a> -->

      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>
  </div>
</template>

<script>
import { EventBus } from '@/event-bus.js'
export default {
  data() {
    return { menuActivo: 'home', menuMobile: false }
  },
  created() {
    EventBus.$on('menu-activo', (menu) => {
      this.menuActivo = menu
    })
  },
  methods: {
    switchLocale(tipo) {
      this.$i18n.locale = tipo
      EventBus.$emit('change-lenguaje', this.$i18n.locale)
    },
    activarMenuMobile(menu) {
      this.menuActivo = menu
      // this.$scrollTo(menu,500, options)
      setTimeout(() => {
        this.menuMobile = false
      }, 150)
    },
    irA(nombre) {
      setTimeout(() => {
        this.menuMobile = false
      }, 150)
      if (nombre === 'trabaja') {
        this.$router.push({ name: 'trabaja-con-nosotros' })
      } else if (nombre === 'home') {
        this.$router.push({ name: 'home' })
      } else {
        this.$router.push({ name: 'home' })
        this.menuActivo = nombre
      }
    },
  },
}
</script>

<style lang="scss">
.menu-ul-mobile {
  list-style: none;
  padding: 0;
  // margin: 20px auto;
}
.menu-ul-mobile li {
  padding: 20px 0px 0px 0px;
  // border: 1px solid #f1f1f1;
  // margin-bottom: 6px;
  // border-radius: 8px;
}
.menu-ul-mobile li > a {
  text-decoration: none;
  font-size: 16px;
  color: $grisMenu;
}
.menu-reducido-right {
  float: right;
  margin-top: 0;
  display: flex;
  align-items: center;
}

.menu-boton-ig-reducido img {
  height: 15px;
  margin-top: -20px;
  display: block;
}

.menu-boton-ig-reducido {
  display: inline-block;
  transition: 500ms;
  margin-left: 20px;
  margin-right: 10px;
}

.menu-boton-in-reducido img {
  height: 17px;
  margin-top: -22px;
  display: block;
}

.menu-boton-in-reducido {
  display: inline-block;
  width: 5px;
  transition: 500ms;
  margin-left: -10px;
}

.menu-boton-yt-reducido img {
  height: 10px;
  display: block;
  margin-top: -16px;
}

.menu-boton-yt-reducido {
  display: inline-block;
  width: 5px;
  transition: 500ms;
  margin-left: 22px;
}

// mobiel

.menu-boton-mobile img {
  height: 36px;
  // width: 100px;
  display: block;
  margin: 0px;
  text-align: center;
}

.menu-boton-mobile {
  display: inline-block;
  // width: 5px;
  transition: 500ms;
  // margin: 0px 40px;
  text-align: center;
  // margin-left: 60px;
  margin-top: 40px;
}

//
.menu-reducido {
  height: 96px;
  background: #fff;
  -webkit-box-shadow: 6px 3px 3px 0 rgba(105, 105, 105, 0.1);
  box-shadow: 6px 3px 3px 0 rgba(105, 105, 105, 0.1);
  position: fixed;
  left: 0;
  right: 0;
  z-index: 99;
}

.logo-reducido {
  margin-left: 20%;
  height: 40px;
  // z-index: -999;
  // margin-top: 10px;
  pointer-events: none !important;

  // cursor: pointer;
}

.logo-mobile {
  height: 60px;
  margin: 0px auto;
  display: block;
  // cursor: pointer;
  pointer-events: none;

  margin-top: 10px;
}

.menu-boton-carro-reducido {
  border: 1.4px solid #fff;
  color: #fff;
  margin-right: 15px;
  display: inline-block;
  // padding: 3.1px 12px;
  border-radius: 50%;
  // transform: translateY(-9px);
  transition: all 0.3s;
  width: 32px;
  height: 32px;
  transform: translateY(0px);
}

.menu-boton-carro-reducido:hover {
  background: $naranja;
  color: white;
}
.menu-boton-webmail-reducido i,
.menu-boton-carro-reducido i {
  padding: 8px 0px 0px 8px;
  text-align: center;
}
.menu-boton-webmail-reducido {
  border: 1.4px solid $azul;
  color: $azul;
  margin-right: 15px;
  display: inline-block;
  // padding: 3.1px 12px;
  border-radius: 50%;
  // transform: translateY(-9px);
  transition: all 0.3s;
  // margin-top: 10px;
  width: 32px;
  height: 32px;
  transform: translateY(-7px);
}

.menu-boton-webmail-reducido:hover {
  background: $azul;
  color: white;
}

.es-reducido {
  height: 14px;
  display: inline-block;
  margin: 0 auto;
  margin-top: 0px;
  margin-left: 20px;
  // padding: 6.1px 4px;
  cursor: pointer;
  margin-top: 0px;
}

.en-reducido {
  height: 15px;
  display: inline-block;
  margin: 0 auto;
  margin-top: 0px;
  margin-left: 10px;
  padding: 6.1px 4px;
  cursor: pointer;
  margin-top: -20px;
}

.menu-reducido ul {
  list-style: none;
  padding: 0;
  display: inline-block;
  margin: 0;
  margin-top: -10px;
  transform: translateY(-8px);
  margin-right: 20px;

  // margin-right: 10%;
}

.menu-reducido ul > li {
  display: inline;
  padding: 10px;
}

.menu-reducido ul > li > a {
  font-family: 'Asap', sans-serif;
  text-decoration: none;
  font-weight: 900;
  color: rgba(6, 64, 103, 0.6);
  text-transform: uppercase;
  line-height: 5;
  transition: all 0.5s;
  font-size: 14px;
}

.menu-reducido ul > li > a:hover,
.menuActivo {
  color: $amarillo !important;
}
@media (orientation: portrait) {
  @media screen and (min-width: 768px) and (max-width: 991px) {
    // .logo-reducido {
    //   height: 50px;
    //   padding: 5% 60%;
    //   margin-left: 20%;
    // }
    .logo-reducido {
      height: 100%;
      padding: 10% 50%;
      margin-left: 20%;
    }
    .menu-reducido-right {
      float: right;
      // margin-top: 17px;
      margin-top: 7%;
      padding: 4px 10px;
      margin-right: 5%;
    }
    .menu-reducido {
      height: 128px;
      background: #fff;
      -webkit-box-shadow: 6px 3px 3px 0 rgba(105, 105, 105, 0.1);
      box-shadow: 6px 3px 3px 0 rgba(105, 105, 105, 0.1);
      position: fixed;
      left: 0;
      right: 0;
      z-index: 99;
    }
  }
  @media screen and (max-width: 767px) {
    .logo-reducido {
      height: 60px;
      padding: 5% 20%;
    }

    .menu-reducido-right {
      float: inline-end;
      margin-top: 13%;
      // margin-top: 7%;
      margin-right: 6%;
    }

    .es-reducido {
      height: 12px;
      padding: 9px 8px;
      margin: 0px;
      cursor: pointer;
      // margin-top: 15px;
      display: inline-block;
      margin-left: -10px;
    }

    .en-reducido {
      height: 12px;
      padding: 9px 8px;
      margin: 0px;
      cursor: pointer;
      margin-top: 0px;
    }
  }
  @media screen and (max-width: 374px) {
    .logo-reducido {
      height: 60px;
      padding: 5% 20%;
    }
    .menu-reducido-right {
      float: inline-end;
      margin-top: 14%;
      margin-right: 7%;
    }
    .menu-reducido {
      height: 96px;
      background: #fff;
      -webkit-box-shadow: 6px 3px 3px 0 rgba(105, 105, 105, 0.1);
      box-shadow: 6px 3px 3px 0 rgba(105, 105, 105, 0.1);
      position: fixed;
      left: 0;
      right: 0;
      z-index: 99;
    }
  }
  @media (max-width: 330px) and (max-height: 620px) {
    .logo-reducido {
      height: 35px;
      // padding: 4px 10px;
      padding: 15% 25%;
    }

    .menu-reducido-right {
      float: right;
      margin-top: 14%;
      margin-right: 7%;
    }

    .es-reducido {
      height: 12px;
      padding: 8px;
      margin: 0px;
      cursor: pointer;
      // margin-top: 30px;
      display: inline-block;
    }

    .en-reducido {
      height: 12px;
      padding: 8px;
      margin: 0px;
      cursor: pointer;
      margin-top: 30px;
      display: inline-block;
    }

    .menu-boton-carro-reducido {
      padding: 2px 8px;
    }

    .menu-boton-webmail-reducido {
      padding: 2px 8px;
    }
    .menu-reducido {
      height: 80px;
      background: #fff;
      -webkit-box-shadow: 6px 3px 3px 0 rgba(105, 105, 105, 0.1);
      box-shadow: 6px 3px 3px 0 rgba(105, 105, 105, 0.1);
      position: fixed;
      left: 0;
      right: 0;
      z-index: 99;
    }
  }
}

@media (orientation: landscape) and (max-height: 667px) {
  .menu-reducido-right {
    float: right;
    margin-top: 6%;
    margin-right: 7%;
  }
  .logo-mobile {
    height: 60px;
    margin: 0px auto;
    display: block;
    pointer-events: none;
    margin-top: 12px;
  }

  .logo-reducido {
    margin-left: 30%;
    pointer-events: none !important;
  }
}
.btn-link {
  background: #000 !important;
  border: 1px solid #fff !important;
  display: block;
  width: 100%;
  padding: 20px 20px;
  border-radius: 5px;
  font-size: 17px !important;
  // margin-bottom: 10px;
  text-align: left;
  color: white;
  font-family: 'roboto-regular';
}
.btn-link-orange {
  background: #d35915 !important;
  border: 1px solid #d35915 !important;
  display: block;
  width: 100%;
  padding: 20px 20px;
  border-radius: 5px;
  font-size: 16px !important;
  // margin-bottom: 10px;
  text-align: left;
  color: white !important;
  font-family: 'roboto-regular';
}
.btn-link-orange a {
  color: inherit;
  text-decoration: none;
  display: block;
  width: 100%;
  height: 100%;
  font-family: 'MONTSERRAT-WHT';
}
// style="background-color: #d35915; border-color: #d35915"
.btn-link a {
  color: inherit;
  text-decoration: none;
  display: block;
  width: 100%;
  height: 100%;
}
// .btn-link a {
//   color: #fff;
//   text-decoration: none;
//   // font-weight: 600;
//   display: block;
//   width: 100%;
// }
</style>
<style scoped>
.body-mobil >>> .el-dialog__body {
  padding: 30px 20px;
  color: white !important;
  font-size: 14px;
  word-break: break-all;
  background-color: black;
}
.el-button:focus,
.el-button:hover {
  color: #ea5b0c;
  border-color: #c6e2ff;
  background-color: #ecf5ff;
}
.menu-ul-mobile li > a {
  text-decoration: none;
  font-size: 16px;
  color: white;
}
</style>
